import { crearWhatsAppUrl } from '../../../utils/contactos';

export const createWhatsAppUrl = (message = '') =>
  crearWhatsAppUrl('historia', message || '');
